import { render, staticRenderFns } from "./OrmQuoteItems.vue?vue&type=template&id=56704e2f&scoped=true"
import script from "./OrmQuoteItems.vue?vue&type=script&lang=js"
export * from "./OrmQuoteItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56704e2f",
  null
  
)

export default component.exports